import { Text } from "./text.js";
import { TextStyles, TextTemplate } from "@fluentui/web-components";
import { DesignSystem } from "../design-system.js";
/**
 * The Fabric Text component.
 *
 * @public
 */
export const definition = Text.compose({
    name: `${DesignSystem.prefix}-text`,
    template: TextTemplate,
    styles: TextStyles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=text.definition.js.map